import Mutations from '../../odata/mutations';

export default { ...new Mutations('users'), ...new Mutations('claims') };
